
import { fetchJob } from "../components/services/fetchJob";
import { fetchRecruitment } from "../components/services/fetchRequirement";

export const PaginationMode = async ({
    mode,
    currentPage,
    rowsPerPage,
    perPageTotal,
    setAllJobs,
    setRequirement,
    setPaginationData,
    setRowsPerPage,
    setCurrentPage,
    setTotal,
    setTotalPage,
    setPerPageTotal,
    total,
    BeURL,
    showAlert
}) => {

    if (mode === "job") {
        return await fetchJob(
            BeURL,
            setAllJobs,
            showAlert,
            currentPage,
            rowsPerPage,
            setTotal,
            setTotalPage
        );
    }

    // if (mode === "requirement") {
    //     await fetchRequirement({
    //         BeURL,
    //         setRequirement,
    //         showAlert,
    //         currentPage,
    //         rowsPerPage,
    //         setTotal,
    //         setTotalPage,
    //         setPerPageTotal
    //     });

      

    //     setPaginationData({ currentPage, rowsPerPage, total, perPageTotal });        
    // }

    if (mode === "recruitmentReport") {
        await fetchRecruitment({
            BeURL,
            setRequirement,
            showAlert,
            currentPage,
            rowsPerPage,
            setTotal,
            setTotalPage,
            setPerPageTotal
        });



        setPaginationData({ currentPage, rowsPerPage, total, perPageTotal });
    }
};



